import styles from './StructuredMessageTable.module.scss'

/**
 * StructuredMessageTable - Simple HTML table for structured message responses
 * Based on the original ScoopTable from common, optimized for chat message display
 *
 * @param {Object} props - Component props
 * @param {Object} props.data - Table data
 * @param {Array<{columnName: string, columnType: string}>} props.data.columns - Column definitions
 * @param {Array<Array>} props.data.rows - Row data as 2D array
 */
export const StructuredMessageTable = ({ data }) => {
    const { columns, rows } = data

    if (!columns?.length || !rows?.length) {
        return null
    }

    const isNumericColumn = (columnType) => {
        return ['Integer', 'Decimal', 'Currency', 'Float'].includes(columnType)
    }

    return (
        <div className={styles.container}>
            <div className={styles.wrapper}>
                <table className={styles.table}>
                    <thead>
                        <tr>
                            {columns.map((column, index) => (
                                <th
                                    key={index}
                                    className={`${styles.header} ${isNumericColumn(column.columnType) ? styles.numeric : ''}`}
                                >
                                    {column.columnName}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rowIndex) => (
                            <tr
                                key={rowIndex}
                                className={rowIndex % 2 === 0 ? styles.rowEven : styles.rowOdd}
                            >
                                {row.map((cell, cellIndex) => (
                                    <td
                                        key={cellIndex}
                                        className={`${styles.cell} ${isNumericColumn(columns[cellIndex]?.columnType) ? styles.numeric : ''}`}
                                    >
                                        {cell}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default StructuredMessageTable
